/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Dayjs } from 'dayjs'
import { search } from 'jmespath'
import { STRING_VAR_REG } from '../constants'
import { rendererMap } from '../renderers'
import type { BaseSchema, SchemaType } from '../schemas'

type ValueOrNestedObject<T = any> = {
  [key: string]: T | ValueOrNestedObject<T>
}

type Replaceable = string | ValueOrNestedObject

export function replaceValueWithJMESPath(source: object, target: object) {
  function replace(item: Replaceable): Replaceable {
    if (typeof item === 'string') {
      // 检查字符串是否符合 `${}` 形式
      const match = item.match(STRING_VAR_REG)
      if (match) {
        // 使用 JMESPath 查询 source 对象
        const result = search(source, match[1])
        return result
      }
      return item // 不是 `${}` 形式的字符串，保留原始值
    } else if (Array.isArray(item)) {
      return item.map(replace) // 递归处理数组元素
    } else if (typeof item === 'object' && item !== null) {
      const newObj: ValueOrNestedObject = {}

      Object.keys(item).forEach(key => {
        newObj[key] = replace(item[key])
      })

      return newObj
    }
    return item // 其他类型的值，保留原始值
  }

  return replace(target)
}

export function renderSchemaArray<T extends BaseSchema, S extends object>(
  array?: T[],
  source?: S /** 外部数据源，传递给子组件后子组件可以在其声明周期内读取 **/,
) {
  return array?.map((item, index) => {
    const { type } = item
    const RendererComponent = rendererMap[type as SchemaType]

    if (RendererComponent) {
      return <RendererComponent data={item} source={source} key={`${type}${index}`} />
    }

    return null
  })
}

export const addUtcOffset = (date: Dayjs) => {
  return date.clone().add(date.utcOffset(), 'minutes')
}

export const minusUtcOffset = (date: Dayjs) => {
  return date.clone().add(-date.utcOffset(), 'minutes')
}
